// extracted by mini-css-extract-plugin
export default {"list":"shortcut-list-block-module--list--ff0f4","four":"shortcut-list-block-module--four--31c55"};